import React, { useCallback } from 'react';
import isFunction from 'lodash/isFunction';

const inputField = Component => ({ input, inputProps, onChange: onChangeProp }) => {
  const onChange = useCallback(
    e => {
      const event = e;
      const nativeEvent = e.nativeEvent;
      const value =
        input?.type === 'checkbox' ? nativeEvent?.target?.checked : nativeEvent?.target?.value || e;

      input.onChange(value);

      if (isFunction(onChangeProp)) {
        onChangeProp(event);
      }
    },
    [input, onChangeProp],
  );

  return <Component {...inputProps} {...input} onChange={onChange} />;
};

export default inputField;
